import { PropsWithChildren, useCallback, useState } from 'react';

import PendingInvitationsModal from 'src/Components/Modals/PendingInvitationsModal/PendingInvitationsModal.component';

import {
  OnAcceptCallback,
  PendingInvitationsModalContext,
} from './PendingInvitationsModal.context';

export const PendingInvitationsModalProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onAcceptCallback, setOnAcceptCallback] = useState<OnAcceptCallback | undefined>(undefined);

  const open = useCallback((options?: { onAccept?: OnAcceptCallback }) => {
    if (options?.onAccept) {
      setOnAcceptCallback(() => options.onAccept);
    }
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setOnAcceptCallback(undefined);
  }, []);

  const handleAccept = (data: { asset: { id: string } }) => {
    onAcceptCallback?.(data);
    close();
  };

  return (
    <PendingInvitationsModalContext.Provider value={{ open, close }}>
      {children}

      <PendingInvitationsModal open={isOpen} onCancel={close} onAccept={handleAccept} />
    </PendingInvitationsModalContext.Provider>
  );
};
